/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdangerconfirm2Inputs */

const en_accountdangerconfirm2 = /** @type {(inputs: Accountdangerconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause your account and request permanent deletion? You will be signed out immediately.`)
};

const pt_accountdangerconfirm2 = /** @type {(inputs: Accountdangerconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspender a sua conta e pedir eliminação permanente? Vai ser desautenticado imediatamente.`)
};

/**
* | output |
* | --- |
* | "Pause your account and request permanent deletion? You will be signed out immediately." |
*
* @param {Accountdangerconfirm2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdangerconfirm2 = /** @type {((inputs?: Accountdangerconfirm2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdangerconfirm2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdangerconfirm2(inputs)
	return pt_accountdangerconfirm2(inputs)
});
export { accountdangerconfirm2 as "accountDangerConfirm" }